/**
 * About Page
 * About Us page combining all sections
 */
import React from 'react';

import AboutHero from '../components/AboutHero';
import AboutContent from '../components/AboutContent';
import OurAchievements from '../components/OurAchievements';
import MissionVision from '../components/MissionVision';
import CoreValues from '../components/CoreValues';
import ObjectivesGovernance from '../components/ObjectivesGovernance';

/**
 * About Page Component
 * @returns {JSX.Element} About page with all sections
 */
const AboutPage = () => {
  return (
    <div className="about-page">
      <AboutHero />
      <AboutContent />
      <OurAchievements />
      <MissionVision />
      <CoreValues />
      <ObjectivesGovernance />
    </div>
  );
};

export default AboutPage;
